<template>
    <div class="person-setting-con">
        <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
            <div class="avatar-wrapper">
                <img src="../../assets/images/user-icon.png" class="user-avatar">
                <span class="user-name">{{useInfo.username?useInfo.username:''}}</span>
                <i class="el-icon-caret-bottom" />
            </div>
            <el-dropdown-menu slot="dropdown">
                <router-link to="/userCenter">
                    <el-dropdown-item>个人中心</el-dropdown-item>
                </router-link>
                <router-link to="/changePassword">
                    <el-dropdown-item>修改密码</el-dropdown-item>
                </router-link>
                <router-link to="/">
                    <el-dropdown-item>首页</el-dropdown-item>
                </router-link>
                <el-dropdown-item divided @click.native="logout">
                    <span style="display:block;">退出登录</span>
                </el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>

<script>
    import {removeToken,removeUuid} from '@/utils/auth'
    import {resetRouter} from '@/router'
    export default {
        data(){
            return{

            }
        },
        computed: {
            useInfo:function(){
                return this.$store.getters.userInfo
            },
        },
        created() {
            //console.log(this.$store.getters.userInfo)
        },
        methods: {
            toggleSideBar() {

            },
            logout() {
                removeToken() // must remove  token  first
                removeUuid()
                this.$router.replace({path:'/login'})
                sessionStorage.clear();
            }
        }
    }
</script>

<style scoped>
    .person-setting-con {
        float: right;
        height: 60px;
        line-height: 60px;
    }
    .avatar-container {
      margin-right: 30px;
    }
    .avatar-wrapper {
      position: relative;
      height: 60px;
    }
    .user-avatar {
      cursor: pointer;
      width: 40px;
      height: 40px;
      border-radius: 10px;
      position: relative;
      top: 9px;

    }

    .user-name{
      font-size: 15px;
      line-height: 60px;
      display: inline-block;
      position: relative;
      color: #333;
      top: -7px;
      cursor: pointer;
      margin:0 10px;
    }

    .el-icon-caret-bottom {
      cursor: pointer;
      position: absolute;
      right: -20px;
      top: 20px;
      font-size: 14px;
    }
    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;
    }
</style>



// WEBPACK FOOTER //
// src/layout/header/PersonSetting.vue